import React from 'react'
import { vehicleIcons } from '~/components/slices/simulatorFuel/SimulatorStatic'

export const SimulatorFuelOutputDistances = (data) => {
  const { distances, contentfulData } = data
  const { section1Block3Titre, section1Block3VehicleCategories } =
    contentfulData

  return (
    <div className=" bg-light-green p-10 flex-col gap-6 flex simulator-block simulator-block-3 ">
      <h3 className="title-block text-white mr-8 !mb-0">
        {section1Block3Titre}
      </h3>
      <div className="gap-4 grid-wrap">
        {Object.entries(distances).map(([vehicleType, distance]) => {
          return (
            <div
              key={vehicleType}
              className="py-4 px-5 flex-col gap-6 flex bg-white cell items-center rounded-2xl"
            >
              <div className="mb-auto ">
                <p className="text-18 text-purple font-bold simulator-card-header text-center">
                  {section1Block3VehicleCategories[vehicleType].lib}
                </p>
                {section1Block3VehicleCategories[vehicleType].subLib && (
                  <p className="text-purple  simulator-card-header text-center text-14 pt-2">
                    {`(${section1Block3VehicleCategories[vehicleType].subLib})`}
                  </p>
                )}
              </div>
              <div className="vehicle-icon">
                {
                  vehicleIcons[
                    section1Block3VehicleCategories[vehicleType].icon
                  ]
                }
              </div>
              <p className="text-24 text-purple font-bold">
                {distance.toLocaleString()} km
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )
}
